import React, { useContext } from "react";
import clsx from "clsx";
import { Col, Row, Form } from "react-bootstrap";

import { Select, RequiredMark } from "components";
import {
	RequiredMarkContext,
	ApplicationEntryProgressContext,
} from "components/contexts";
import { generateAutotestValue } from "helpers";

import styles from "./formField.module.scss";

const DropdownReactSelect = ({
	input,
	meta: { touched, error, warning },
	label,
	options = [],
	isDisabled,
	smLabel = 6,
	smSelect = 6,
	tabIndex,
	loading,
	isSearchable = false,
	pleaseSelectText = "Please Select",
	hideRequiredMark, //works only with RequiredMarkContext
	requiredMark,
	wrapperClassName,
	isWhiteLabel = false,
	onMouseEnter,
	onMouseLeave,
	getOptionLabel,
	autoTest = "",
	warningIcon = undefined,
	...props
}) => {
	const showRequiredMark =
		(useContext(RequiredMarkContext) && !hideRequiredMark && !isDisabled) ||
		requiredMark;
	const { triggerSave } = useContext(ApplicationEntryProgressContext);

	const handleBlur = () => {
		input.onBlur(input.value);
		triggerSave?.();
	};

	const showLoader =
		!isDisabled && (loading || (loading === undefined && !options.length));

	const showError = touched && !isDisabled && !showLoader;

	const disabledClass = isDisabled && styles.disabled;

	const errorText =
		showError &&
		((error && <p className={"errorMessage"}>{error}</p>) ||
			(warning && (
				<p className={styles.spanWarn}>
					{warningIcon}
					{warning}
				</p>
			)));

	const labelElement = label && (
		<Form.Label
			column
			sm={smLabel}
			className={`${styles.formGroup} ${disabledClass}`}
		>
			{label}
			{showRequiredMark && <RequiredMark />}
		</Form.Label>
	);

	const fixNullValueLabel = option => {
		const optionValue = option?.value ? option?.value : option?.id;
		const optionLabel = option?.label ? option?.label : option?.name;

		if (optionValue == null) {
			return pleaseSelectText;
		} else if (getOptionLabel) {
			return getOptionLabel(option);
		} else {
			return optionLabel;
		}
	};

	return (
		<Form.Group
			className={clsx(styles.dropdownBlockValid, wrapperClassName)}
			as={Row}
		>
			{labelElement}
			<Col sm={smSelect}>
				<Select
					{...props}
					options={options}
					isSearchable={isSearchable}
					placeholder={pleaseSelectText}
					tabIndex={tabIndex}
					isDisabled={isDisabled}
					loading={showLoader}
					value={input.value}
					onChange={input.onChange}
					onBlur={handleBlur}
					onMouseEnter={onMouseEnter}
					onMouseLeave={onMouseLeave}
					hasError={touched && !!error}
					hasWarning={touched && !!warning}
					getOptionLabel={fixNullValueLabel}
					dataAutotest={`select${generateAutotestValue(
						autoTest,
						input.name,
					)}`}
				/>
				{errorText}
			</Col>
		</Form.Group>
	);
};

export default DropdownReactSelect;
